'use strict';
const keyboardUtls = {
    isEscKey(event) {
        return event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
    },
    isTabKey(event) {
        return event.key === 'Tab' || event.code === 'Tab' || event.keyCode === 9;
    }
};
export default keyboardUtls;
